import React from 'react';

import { getMoment, showDateNoTime } from '@libs/NwMoment';

import TransactionEvent from '@components/Transactions/TransactionEvent';

const hasValidDate = (date) => {
    return Boolean(date) && getMoment(date).year() > 1900;
};

const TransactionRefDate = ({ transaction }) => {
    if (!transaction.WorkDate && hasValidDate(transaction.RefDate)) {
        return <p className="upper">{showDateNoTime(transaction.RefDate)}</p>;
    }

    return null;
};

const getUsageLabel = (project, usageID) => {
    const usage = project?.Usages?.find((item) => item.ID === usageID);

    if (!usage || !usage.Areas?.length) {
        return null;
    }

    return `${usage.Areas[0]} - ${usage.Duration}`.toLocaleLowerCase();
};

const ProjectSummaryMetaCell = ({ row, project, isExpanded = false }) => {
    const transaction = row.Transaction || row;
    const usageLabel = getUsageLabel(project, row.UsageID);

    return (
        <div className="transaction-middle">
            <TransactionEvent transaction={transaction} project={project} />
            {isExpanded && <small>{row.Description || <em className="super-muted">no description</em>}</small>}
            <TransactionRefDate transaction={transaction} />
            {isExpanded && usageLabel && <div>{usageLabel}</div>}
        </div>
    );
};

export default ProjectSummaryMetaCell;
